// import { antPrefixCls } from "utils/antPrefixclsConfig";
import { antPrefixCls } from '../../../../utils/antPrefixclsConfig/index';

/**
 * 本页面所需要的数据：所有的权限(数组)，由上个页面(权限列表页面)存入localstorage, 在本页面初始化时取出解析
 * localstorage.getItem('right_management_allPrivileges')
 */
import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button, Table, Checkbox, Spin, message, Radio, TreeSelect, Tooltip, Modal } from 'antd';
import { cloneDeep, uniq, flow, isEqual } from 'lodash';
import { localStorage, callApi, getUrlQuery, getBasicInfo } from 'utils';
// import SelectModal from 'components/SelectModal';
// import NewSelectModal from "components/NewSelectModal";
import NewSelectModal from '../../../NewSelectModal/index';
import { api } from '../../config';
import './index.less';
import classNames from 'classnames';
const prefixCls = 'eh-right-detail'; // 样式开头名称

const OWNER_TYPE_EH = 'EhOrganizations';
const OWNER_TYPE_USER = 'EhUsers';
const OWNER_TYPE_LABEL = 'EhOrgLabels';
const OWNER_TYPE_POSITION = 'EhPositions'; // const PROJECT_TYPE_COM = 'EhCommunities';

// 选人组件标签类型
const SELECT_MODAL_SOURCE_TYPE = {
	// 岗位
	SOURCE_POSITION: 'source_position',
	// 标签
	SOURCE_LABEL: 'source_label',
	// 部门
	SOURCE_DEPARTMENT: 'source_department',
	// 用户
	SOURCE_USER: 'source_user',
};

const MODULE_CONTROL_TYPE_PLATFORM = 'platform_control';
const MODULE_CONTROL_TYPE_COMMUNITY = 'community_control';
const MODULE_CONTROL_TYPE_ORG = 'org_control';
const TARGET_PLACEHODER = '请点击选择用户或部门';
const PROJECT_PLACEHODER = '请点击选择空间项目';
const DEPARTMENT_PLACEHODER = '请点击选择部门';
const RadioGroup = Radio.Group;
const { SHOW_PARENT, TreeNode } = TreeSelect; // 操作类型

const OPERATION_TYPE_DICT = {
	READ: 'READ',
	// 读权限
	WRITE: 'WRITE', // 写权限
};

const showOrgSelector = () => {
	const { namespaceId } = window.$$context;
	return [1000052].indexOf(namespaceId) === -1;
};

// 统一写一个错误信息组件
function ErrorMessageContianer(props) {
	const { children } = props;

	if (!children) {
		return null;
	}

	return (
		<div
			className={classNames(
				`${antPrefixCls.get()}-form-item-explain`,
				`${antPrefixCls.get()}-form-item-explain-error`,
				`${prefixCls}-form-item-error`,
			)}
		>
			{children}
		</div>
	);
}

// 管理空间项目范围枚举
export const CommunityScopeEnum = {
	// 所有空间项目
	ALL: 1,
	// 选择空间项目
	COMMUNITY: 0,
	// 按照授权的岗位选择
	POSITION: 2,
};

//岗位模式下,获取无效的目标
function getInvalidTargets({ communityScopeValue, selectedObjects }) {
	if (communityScopeValue === CommunityScopeEnum.POSITION) {
		return selectedObjects.map((item) => {
			const isInvalid = item.sourceTypeA !== SELECT_MODAL_SOURCE_TYPE.SOURCE_POSITION;
			return {
				...item,
				isInvalid,
			};
		});
	}
	return selectedObjects.map((item) => {
		return {
			...item,
			isInvalid: undefined,
		};
	});
}
// 全部为无效的目标
function allInvalid(selectedObjects) {
	return selectedObjects.every((item) => item.isInvalid);
}
class RightDetail extends PureComponent {
	constructor(props) {
		super(props);
		const { scopeType, showProjectScope, showDepartmentScope } = this.props;
		let { id, ownerType = OWNER_TYPE_EH, ownerId } = getUrlQuery(props.location.search);
		const { organizationId, moduleControlType } = window.$$context;
		let defaultTargetType = '',
			showProject = showProjectScope,
			showDepartment = showDepartmentScope; // 业务没设置是否展示管理空间项目范围时，如果是园区应用，默认展示；否则，不展示

		if (showProject === undefined) {
			showProject = moduleControlType === 'community_control';
		} // 业务没设置是否展示管理企业范围时，如果是企业应用，默认展示；否则，不展示

		if (showDepartment === undefined) {
			showDepartment = moduleControlType === 'org_control';
		} // if (moduleControlType === 'community_control') {
		// 	defaultTargetType = 'project';
		// } else if (moduleControlType === 'org_control') {
		// 	defaultTargetType = 'department';
		// }
		// scopeType = scopeType || defaultTargetType;

		ownerId = ownerId || organizationId;
		this.state = {
			ownerType,
			ownerId,
			id,
			// 编辑权限时传入
			allPrivileges: [],
			// 所有权限
			rightIds: [],
			// 权限id集合(只包含权限的id, 不包含分类的id)
			isChoosedAll: false,
			// 是否全选
			isChoosedDisabled: false,
			// 全选是否禁用
			readOnly: props.type === 'view',
			// 查看模式下，所有勾选框只读
			hideProjectBox: moduleControlType === MODULE_CONTROL_TYPE_PLATFORM,
			// 是否隐藏数据选择框
			showObjectModal: false,
			// 显示对象选择框
			// 选择的对象包含无效的对象,
			// 根据岗位空间权限时,会根据岗位tab的选择情况,选择的对象可能会有无效的情况
			selectedObjects: [],
			// 选择的对象
			tmpSelectedObjects: [],
			// 传入选择对象弹框的数据
			showProjectsModal: false,
			// 显示数据范围选择框
			scopeDatas: [],
			// 选择的空间项目
			tmpScopeDatas: [],
			// 传入数据范围选择弹框的数据
			allProjectFlag: false,
			// 是否选择了全部空间项目
			// 选择框提示语
			targetTip: '',
			scopeTip: '',
			btnLoading: false,
			// 发送请求中
			preLoading: true,
			// 数据的加载
			customValues: [],
			// 自定义组件的属性
			scopeType,
			// 数据范围
			allProjectList: [],
			// 所有空间项目
			departmentsMap: null,
			// 所有部门的 id -- name 映射
			selectedOperations: [],
			// 当前选择的功能权限内容
			assignmentId: null,
			// 授权Id
			// 是否展示‘管理空间项目范围’
			showProject,
			// 是否展示‘管理企业范围’
			showDepartment,
			// 空间项目树数据
			projectTree: [],
			// 所有空间项目范围标识
			allCommunityScopeFlag: 1,
			// 是否禁用选择’全部空间项目‘
			allProjectDisabled: false,
			// 空间项目数据范围
			communityScope: [],
			// 公司数据范围
			departmentScope: [],
			// 组织架构树
			organizationTree: [],
			// 所有部门范围标志
			allOrgScopeFlag: 1,
			// 是否禁用选择’全公司‘
			allDepartmentDisabled: false,
			// 部门数据范围
			orgScope: [],
			// 自定义数据(后台虽然写死了只有2个自定义组件，且用两个字段表示其对应的数据，但为方便后面扩展，这里存入数组统一处理)
			customizeDatum: [],
			// 不可选用户列表
			disabledSelects: [],
			// 是否点击过提交
			submitBtnClicked: false,
			// 是否显示授权提示信息
			showAuthError: false,
			authErrorMessage: '请选择授权对象',
			// 是否显示管理空间项目范围提示信息
			showProjectScopeError: false,
			// 是否显示管理企业范围提示信息
			showDepartmentScopeError: false,
			// 是否显示功能权限提示信息
			showModuleAccessError: false,
			// 自定义组件校验报错记录的字典
			customComponentError: {},
			// needJobSubdivide: false,
		};
	}

	componentDidUpdate(prevProps, prevState) {
		const { allCommunityScopeFlag, selectedObjects } = this.state;
		if (
			allCommunityScopeFlag !== prevState.allCommunityScopeFlag ||
			!isEqual(selectedObjects, prevState.selectedObjects)
		) {
			console.log('componentDidUpdate', allCommunityScopeFlag, selectedObjects);
			const authModalSelects = getInvalidTargets({ communityScopeValue: allCommunityScopeFlag, selectedObjects });
			console.log(authModalSelects, 'authModalSelects');
			this.setState({
				selectedObjects: authModalSelects,
			});
		}
	}

	componentDidMount() {
		Promise.all([this.getHasAppManagePrivilegesUsers(), this.getSupAdminInfo()]).then((values) => {
			let disabledSelects = [];
			const { adminInfos = [] } = values[0];
			disabledSelects = adminInfos.map((admin) => ({
				sourceIdA: admin.userId,
				flowUserSelectionType: 'person',
				targetPath: admin.groupPath,
			}));
			disabledSelects.push({
				sourceIdA: values[1].userId,
				flowUserSelectionType: 'person',
			});
			this.setState({
				disabledSelects,
			});
		});
		Promise.all([
			this.listAllCommunities(), //  this.getDepartmentsMap(),
			this.getAuthorizedCommunities(),
			this.getAuthorizedDepartments(),
			showOrgSelector() && this.listAllChildrenOrganizations(),
		]).then(() => {
			this.setState((state) => {
				return this.getAllPrivilegesAndSelectedData(this.props.type);
			});
		}); // cardCenterScope 领卷中心

		const { cardCenterScope = false } = this.props; // 是否展示项目树

		cardCenterScope &&
			callApi({
				api: api.getCouponCenterConfig,
				service: 'prmt',
				data: {},
				success: ({ ifCommunityCouponCenter = true }) => {
					this.setState({
						showProject: ifCommunityCouponCenter,
					});
				},
			});
	}

	/**
	 * 获取所有空间项目
	 */
	listAllCommunities() {
		const { organizationId } = window.$$context;
		return callApi({
			api: api.getSpacePros,
			data: {
				orgId: organizationId,
				assignmentSourceTypes: ['SUP_ADMIN', 'SYS_ADMIN', 'APP_ADMIN'],
			},
			success: (res) => {
				const { authorizedCommunities = [] } = res || {};
				const departmentsMap = new Map();

				const generateMap = (communities) => {
					communities.forEach((community) => {
						const { projectId, projects = [] } = community;
						departmentsMap.set('' + projectId, community);

						if (projects.length) {
							generateMap(projects);
						}
					});
				};

				generateMap(authorizedCommunities);
				this.setState({
					allProjectList: authorizedCommunities,
					departmentsMap,
				});
			},
			error: (err) => {
				message.error(`获取空间项目数据出错 ${err && err.errorDescription ? err.errorDescription : ''}`);
			},
		});
	}
	/**
	 * 获取所有部门的 id -- name 映射
	 */

	getDepartmentsMap() {
		const { namespaceId, organizationId } = window.$$context;
		return callApi({
			api: api.getDepartments,
			data: {
				namespaceId,
				orgId: organizationId,
			},
			success: (res) => {
				const departmentsMap = new Map();

				for (const item of res) {
					departmentsMap.set(item.id, item.name);
				}

				this.setState({
					departmentsMap,
				});
			},
			error: (err) => {
				message.error(`获取部门数据出错 ${err && err.errorDescription ? err.errorDescription : ''}`);
			},
		});
	} // 获取空间项目数据

	getAuthorizedCommunities = () => {
		const { organizationId } = window.$$context;
		return callApi({
			defaultError: false,
			api: api.getAuthorizedCommunities,
			data: {
				orgId: organizationId,
				assignmentSourceTypes: ['SUP_ADMIN', 'SYS_ADMIN', 'APP_ADMIN'],
			},
		})
			.then((res = {}) => {
				this.setState({
					projectTree: res.authorizedCommunities || [],
					allProjectDisabled: res.allCommunityFlag !== 1,
					allCommunityScopeFlag: res.allCommunityFlag,
				});
			})
			.catch((err) => {
				message.error(`空间项目数据获取失败，${err.errorDescription || ''}`);
			});
	}; // 获取公司范围数据

	getAuthorizedDepartments = () => {
		const { organizationId, appId } = window.$$context;
		return callApi({
			defaultError: false,
			api: api.getAuthorizedDepartments,
			data: {
				orgId: organizationId,
				userId: getBasicInfo('userInfo').id,
				appId,
				assignmentSourceTypes: ['SUP_ADMIN', 'SYS_ADMIN', 'APP_ADMIN'],
			},
		})
			.then((res = {}) => {
				this.setState({
					allDepartmentDisabled: res.allDepartmentFlag !== 1,
					allOrgScopeFlag: res.allDepartmentFlag,
					departmentScope: res.authorizedDepartmentIds || [],
				});
			})
			.catch((err) => {
				message.error(`公司范围获取失败，${err.errorDescription || ''}`);
			});
	}; // 获取组织架构树

	listAllChildrenOrganizations = () => {
		const { organizationId } = window.$$context;
		return callApi({
			defaultError: false,
			api: api.listAllChildrenOrganizations,
			data: {
				id: organizationId,
				groupTypes: ['ENTERPRISE', 'DEPARTMENT', 'GROUP'],
			},
		})
			.then((res = {}) => {
				this.setState({
					organizationTree: [res.organizationMenu || {}],
				});
			})
			.catch(() => {
				message.error('组织架构树获取失败');
			});
	}; // 获取有应用管理权限的人员列表

	getHasAppManagePrivilegesUsers = () => {
		const { organizationId, appId } = window.$$context;
		return callApi({
			api: api.getHasAppManagePrivilegesUsers,
			data: {
				orgId: organizationId,
				appId,
				pageSize: 9999,
			}, // success: (res = {}) => {
			// 	const { sysAdminInfos = [] } = res;
			// 	this.setState({
			// 		disabledSelects: sysAdminInfos.map(admin => ({sourceIdA: admin.userId, flowUserSelectionType: 'person'}))
			// 	});
			// },
			// error: () => {
			// 	message.error('管理员获取失败');
			// }
		});
	}; // 获取超管信息

	getSupAdminInfo = () => {
		const { organizationId } = window.$$context;
		return callApi({
			api: api.getSupAdminInfo,
			data: {
				orgId: organizationId,
			},
		});
	}; // 根据页面类型处理权限数据

	getAllPrivilegesAndSelectedData = (type) => {
		let allPrivileges = [],
			selectedOperations = [];

		try {
			allPrivileges = JSON.parse(localStorage.read('right_management_allPrivileges'));

			if (!allPrivileges) {
				allPrivileges = [];
				type = 'add';
			} else {
				selectedOperations = Array(allPrivileges.length);
			}
		} catch (e) {
			message.error('数据错误', 1.5);
			this.props.history.goBack();
			return;
		}

		if (type === 'view' || type === 'edit') {
			try {
				const {
					assignedOperations = [],
					assignedDataScope = {},
					targets = [],
					customizeDatum = [],
					assignmentId,
					allOrgScopeFlag,
					orgScope = [],
					allCommunityScopeFlag,
					communityScope = [],
					customizeDatum1 = [],
					customizeDatum2 = [],
					allOperationFlag,
				} = JSON.parse(localStorage.read('right_management_record'));
				const { departmentsMap } = this.state; // 授权的权限id集合

				const assignedOperationIds = [];
				assignedOperations.forEach((item) => {
					(item.operations || []).forEach((opera) => assignedOperationIds.push(opera.id));
				}); // 回填功能权限

				for (let i = 0; i < allPrivileges.length; i++) {
					const item = allPrivileges[i];
					const tmpSelectedOperationsItem = {
						categoryId: item.categoryId,
						allOperationFlag: 0,
						assignedOperations: [],
					};

					for (const operation of item.operations) {
						if (
							allOperationFlag === 1 ||
							assignedOperationIds.includes(operation.id) ||
							operation.defaultSelect === 1
						) {
							operation.checked = true;
						}

						if (item.operations.every((op) => op.checked === true) || item.defaultSelect === 1) {
							item.checked = true;
							tmpSelectedOperationsItem.allOperationFlag = 1;
						}

						if (item.operations.every((op) => op.defaultSelect === 1) || item.defaultSelect === 1) {
							item.disabled = true;
						}
					}

					tmpSelectedOperationsItem.assignedOperations = item.operations
						.filter((oper) => oper.checked === true)
						.map((oper) => oper.id);
					selectedOperations[i] = tmpSelectedOperationsItem;
				}

				const selectedObjects = targets.map(({ targetName, targetId, targetType, targetId2 }) => {
					let sourceTypeA = '',
						flowUserSelectionType = '',
						sourceTypeB;

					if (targetType === OWNER_TYPE_USER) {
						sourceTypeA = 'source_user';
						flowUserSelectionType = 'person';
					} else if (targetType === OWNER_TYPE_EH) {
						sourceTypeA = 'source_department';
						flowUserSelectionType = 'department';
					} else if (targetType === OWNER_TYPE_LABEL) {
						sourceTypeA = 'source_label';
						flowUserSelectionType = 'label';
					} else if (targetType === OWNER_TYPE_POSITION) {
						sourceTypeA = 'source_position';
						flowUserSelectionType = 'position';
						sourceTypeB = 'source_department';
					}

					const ret = {
						selectionName: targetName,
						sourceIdA: targetId,
						sourceTypeA,
						flowUserSelectionType,
						sourceTypeB,
					};

					if (targetId2 !== undefined) {
						ret.sourceIdB = targetId2;
					}

					return ret;
				});
				const isChoosedAll = allPrivileges.every((p) => p.checked === true);
				const isChoosedDisabled = allPrivileges.every((p) => p.disabled === true);
				return {
					allPrivileges,
					isChoosedAll,
					isChoosedDisabled,
					// targetTip: targetName,
					selectedOperations,
					// scopeTip,
					selectedObjects,
					// scopeDatas,
					// customValues: customizeDatum,
					customizeDatum: [customizeDatum1, customizeDatum2],
					assignmentId,
					preLoading: false,
					allCommunityScopeFlag,
					communityScope: communityScope.filter((id) => departmentsMap.has(id.toString())),
					allOrgScopeFlag,
					orgScope,
				};
			} catch (error) {
				console.error(error);
			}
		}

		for (let i = 0; i < allPrivileges.length; i++) {
			const item = allPrivileges[i];
			item.operations.forEach((p) => {
				p.checked = p.defaultSelect === 1;
			});
			item.checked = item.defaultSelect === 1 || item.operations.every((p) => p.checked);
			item.disabled = item.defaultSelect === 1 || item.operations.every((p) => p.defaultSelect === 1);
			selectedOperations[i] = {
				allOperationFlag: item.checked ? 1 : 0,
				assignedOperations: item.operations.filter((p) => p.checked).map((p) => p.id),
				categoryId: item.categoryId,
			};
		}

		const isChoosedAll = allPrivileges.every((p) => p.checked === true);
		const isChoosedDisabled = allPrivileges.every((p) => p.disabled === true);
		return {
			allPrivileges,
			selectedOperations,
			readOnly: false,
			preLoading: false,
			isChoosedAll,
			isChoosedDisabled,
		};
	}; // 勾选/取消勾选 分类

	toggleRowAllRights = (e, index) => {
		const flag = e.target.checked;
		let { selectedOperations, allPrivileges, isChoosedAll } = this.state;
		const newAllPrivileges = [...allPrivileges];
		let newOperations = [...selectedOperations[index].assignedOperations];
		const privilege = cloneDeep(allPrivileges[index]);
		const newSelectedOperations = selectedOperations.slice(0);
		newSelectedOperations[index].allOperationFlag = flag ? 1 : 0;
		privilege.checked = flag;
		newAllPrivileges[index] = privilege;

		if (flag) {
			privilege.operations.forEach((operation) => {
				operation.checked = flag;
				const id = operation.id;

				if (!newOperations.includes(id)) {
					newOperations.push(id);
				}
			});
			isChoosedAll = newAllPrivileges.every((p) => p.checked);
		} else {
			privilege.operations.forEach((operation) => {
				operation.checked = operation.defaultSelect === 1;

				if (operation.defaultSelect !== 1) {
					const id = operation.id;
					newOperations = uniq(newOperations.filter((item) => item !== id));
				}
			});
			isChoosedAll = false;
		}

		newSelectedOperations[index].assignedOperations = newOperations.slice(0);
		this.setState({
			selectedOperations: newSelectedOperations,
			allPrivileges: newAllPrivileges,
			isChoosedAll,
		});
	}; // 选择/取消选择 权限

	toggleChooseRight = (e, rowIndex, rightIndex) => {
		const flag = e.target.checked;
		let { selectedOperations, allPrivileges, isChoosedAll } = this.state;
		let newOperations = [...selectedOperations[rowIndex].assignedOperations],
			newAllPrivileges = [...allPrivileges],
			operation;
		const privilege = cloneDeep(allPrivileges[rowIndex]);
		const newSelectedOperations = selectedOperations.slice(0);
		newAllPrivileges[rowIndex] = privilege;
		operation = privilege.operations[rightIndex];
		operation.checked = flag;

		if (flag) {
			if (operation.operationType === OPERATION_TYPE_DICT.WRITE) {
				// 勾选一个写权限时，所有的读权限自动勾选
				privilege.operations.forEach((it) => {
					if (it.operationType === OPERATION_TYPE_DICT.READ) {
						it.checked = flag;

						if (!newOperations.includes(it.id)) {
							newOperations.push(it.id);
						}
					}
				});
			}

			privilege.checked = privilege.operations.every((m) => m.checked);
			newSelectedOperations[rowIndex].allOperationFlag = privilege.checked ? 1 : 0;
			isChoosedAll = newAllPrivileges.every((p) => p.checked);

			if (!newOperations.includes(operation.id)) {
				newOperations.push(operation.id);
			}
		} else {
			if (
				operation.operationType === OPERATION_TYPE_DICT.READ &&
				!privilege.operations.some((it) => it.operationType === OPERATION_TYPE_DICT.READ && it.checked)
			) {
				// 取消勾选最后一个读权限时，所有的写权限自动取消勾选
				privilege.operations.forEach((it) => {
					if (it.operationType === OPERATION_TYPE_DICT.WRITE) {
						it.checked = flag;
						newOperations = uniq(newOperations.filter((item) => item !== it.id));
					}
				});
			}

			privilege.checked = false;
			newSelectedOperations[rowIndex].allOperationFlag = 0;
			isChoosedAll = false;
			newOperations = uniq(newOperations.filter((item) => item !== operation.id));
		}

		newSelectedOperations[rowIndex].assignedOperations = newOperations.slice(0);
		this.setState({
			selectedOperations: newSelectedOperations,
			allPrivileges: newAllPrivileges,
			isChoosedAll,
		});
	}; // 全选/取消全选

	toggleAll = () => {
		let { selectedOperations, allPrivileges, isChoosedAll } = this.state;
		const newAllPrivileges = cloneDeep(allPrivileges);
		const newSelectedOperations = selectedOperations.slice(0);
		isChoosedAll = !isChoosedAll;

		for (let i = 0; i < newAllPrivileges.length; i++) {
			const item = newAllPrivileges[i];
			item.operations.forEach((operation) => {
				operation.checked = operation.defaultSelect === 1 || isChoosedAll;
			});
			item.checked = item.operations.every((p) => p.checked);
			newSelectedOperations[i].allOperationFlag = item.checked ? 1 : 0;
			newSelectedOperations[i].assignedOperations = item.operations.filter((p) => p.checked).map((p) => p.id);
		}

		this.setState({
			selectedOperations: newSelectedOperations,
			allPrivileges: newAllPrivileges,
			isChoosedAll,
		});
	};
	/**
	 * 检查是否选择了功能权限
	 */

	checkOperationsSelect = (selectedOpers = []) => {
		for (const item of selectedOpers) {
			if (item == null) continue;
			if (item.allOperationFlag || (item.assignedOperations && item.assignedOperations.length > 0)) return true;
		}

		return false;
	};
	/**
	 * 新增或更新规则
	 */

	addOrUpdateRule = async () => {
		const {
			selectedObjects,
			scopeDatas,
			selectedOperations,
			hideProjectBox,
			allProjectList,
			customValues,
			scopeType,
			assignmentId,
			departmentsMap,
			isChoosedAll,
			showProject,
			showDepartment,
			allOrgScopeFlag,
			orgScope,
			allCommunityScopeFlag,
			communityScope,
			customizeDatum,
			allOperationFlag,
		} = this.state;
		const { type, hideScope, hideDefaultScope, onSave, showPrivilege, customComponentList, history } = this.props;
		const { appId, moduleControlType, namespaceId, organizationId } = window.$$context;
		this.setState({
			submitBtnClicked: true,
		});

		if (this.getBtnDisabledStatus()) {
			return;
		}
		let validSelectedObjects = selectedObjects;
		// 选择中不包含无效对象，则需要弹出提示框
		if (validSelectedObjects.some((item) => item.isInvalid)) {
			const ModalPromise = () => {
				return new Promise((resolve, reject) => {
					const validTargets = validSelectedObjects.filter((item) => !item.isInvalid);
					const validTargetsStringify = validTargets.map((item) => item.selectionName).join('，');
					Modal.confirm({
						content: `权限规则仅针对${validTargetsStringify}生效`,
						onOk: (close) => {
							resolve('ok');
							close();
							validSelectedObjects = validTargets;
						},
						onCancel: (close) => {
							reject('onCancel');
							close();
						},
					});
				});
			};
			await ModalPromise();
		}
		// return;
		const requestParams = {
			namespaceId,
			orgId: organizationId,
			appId,
			targets: validSelectedObjects.map((o) => {
				let targetType = '',
					data = {};

				if (o.sourceTypeA === 'source_user') {
					targetType = OWNER_TYPE_USER;
				} else if (o.sourceTypeA === 'source_department') {
					targetType = OWNER_TYPE_EH;
				} else if (o.sourceTypeA === 'source_label') {
					targetType = OWNER_TYPE_LABEL;
				} else if (o.sourceTypeA === 'source_position') {
					targetType = OWNER_TYPE_POSITION;
					data.targetId2 = o.sourceIdB;
				}

				data = {
					...data,
					targetId: o.sourceIdA,
					targetName: o.selectionName,
					targetType,
				};
				return data;
			}),
		};
		// 空间项目范围
		if (showProject) {
			requestParams.allCommunityScopeFlag = allCommunityScopeFlag;

			if (allCommunityScopeFlag === CommunityScopeEnum.COMMUNITY) {
				// antd TreeSelect返回的数据是对象，旧版本的好像只返回id。为以防antd修改，这里需要做兼容处理
				const projectScope = [];
				communityScope.forEach((item) => {
					const value = item.value || item;
					const currentCommunity = departmentsMap.get('' + value);
					const { projectId, projectName, projectType } = currentCommunity;
					projectScope.push({
						projectId,
						projectName,
						projectType,
					});
				});
				requestParams.communityScope = communityScope.map((item) => item.value || item);
				requestParams.projectScope = projectScope;
			}
		} else {
			requestParams.allCommunityScopeFlag = 1;
		}
		// 企业范围
		if (showDepartment) {
			requestParams.allOrgScopeFlag = allOrgScopeFlag;

			if (allOrgScopeFlag === 0) {
				// antd TreeSelect返回的数据是对象，旧版本的好像只返回id。为以防antd修改，这里需要做兼容处理
				requestParams.orgScope = orgScope.map((item) => {
					if (item.value) {
						return item.value;
					}

					return item;
				});
			}
		} else {
			requestParams.allOrgScopeFlag = 1;
		} // 自定义组件

		const customComponentNum = customComponentList.length;

		if (customComponentNum > 0) {
			requestParams.customizeDatum1 = customizeDatum[0];

			if (customComponentNum > 1) {
				requestParams.customizeDatum2 = customizeDatum[1];
			}
		}
		// 权限
		if (showPrivilege) {
			if (isChoosedAll) {
				requestParams.allOperationFlag = 1;
			} else {
				requestParams.allOperationFlag = 0;
				let assignedOperationIds = [];
				selectedOperations.forEach((selected) => {
					assignedOperationIds = [...assignedOperationIds, ...(selected.assignedOperations || [])];
				});
				requestParams.assignedOperationIds = assignedOperationIds;
			}
		} else {
			requestParams.allOperationFlag = 1;
		}

		if (type === 'edit') {
			// 更新规则
			requestParams.assignmentId = assignmentId;
		} else if (type !== 'add') {
			return;
		}
		// console.log(requestParams);
		// return;
		this.setState({
			btnLoading: true,
		});
		callApi({
			api: api.resetOperationAuthorizations,
			data: requestParams,
			success: () => {
				message.success('操作成功');
				onSave && onSave(type, requestParams);
				history.goBack();
			},
			error: () => {
				message.error('操作失败，请重试');
			},
			complete: () => {
				this.setState({
					btnLoading: false,
				});
			},
		});
	}; // 打开对象选择对话框

	openObjectModal = () => {
		this.setState((preState, props) => ({
			showObjectModal: true,
			tmpSelectedObjects: cloneDeep(preState.selectedObjects),
		}));
	};

	// 确认选择对象
	confirmSelectObjects = () => {
		this.setState((preState) => {
			const { tmpSelectedObjects } = preState;
			return {
				showObjectModal: false,
				selectedObjects: cloneDeep(tmpSelectedObjects),
				tmpSelectedObjects: [],
			};
		});
	};

	// 取消选择对象
	cancelSelectObjects = () => {
		this.setState({
			showObjectModal: false,
			tmpSelectedObjects: [],
		});
	}; // 修改自定义组件数据

	onCustomComponentChange = (values = [], componentIndex = 0, cb) => {
		const customizeDatum = cloneDeep(this.state.customizeDatum);
		customizeDatum[componentIndex] = values;
		this.setState(
			{
				customizeDatum,
			},
			cb,
		); // this.setState({
		// 	customValues: values
		// }, cb);
	}; // 移除选择的对象

	removeTarget = (target) => {
		let selectedObjects = cloneDeep(this.state.selectedObjects);
		selectedObjects = selectedObjects.filter(
			(item) => item.sourceIdA !== target.sourceIdA || item.sourceTypeA !== target.sourceTypeA,
		);
		this.setState({
			selectedObjects,
		});
	}; // 修改空间项目范围是否是全部

	toggleAllProject = (e) => {
		this.setState({
			allCommunityScopeFlag: e.target.value,
		});
	}; // 更新选择的公司范围

	updateOrgDataScope = (e) => {
		this.setState({
			allOrgScopeFlag: e.target.value,
		});
	}; // 树节点过滤

	filterTreeNode = (inputValue, treeNode) => {
		return treeNode.title.indexOf(inputValue) > -1;
	}; // 渲染空间项目树结构

	renderProjectTree = (data) => {
		// const { projectTree = [] } = this.state;
		return data.map((node) => {
			const { projects = [], projectId, projectName } = node; // const disabled = projectTree.every(p => p.projectId !== projectId);

			if (projects && projects.length > 0) {
				return (
					<TreeNode
						key={projectId.toString()}
						value={projectId.toString()}
						title={projectName}
						data-item={node} // disabled={disabled}
					>
						{this.renderProjectTree(projects)}
					</TreeNode>
				);
			}

			return (
				<TreeNode
					key={projectId.toString()}
					value={projectId.toString()}
					title={projectName}
					data-item={node} // disabled={disabled}
				/>
			);
		});
	}; // 渲染组织架构树结构

	renderOrganizationTree = (data) => {
		const { departmentScope } = this.state;
		return data.map((node) => {
			const { childrens = [], id, name, path } = node; // 如果该节点不在可选范围内，禁用

			const disabled = path
				.split('/')
				.filter((id) => id)
				.every((id) => departmentScope.every((item) => item.toString() !== id.toString()));

			if (childrens && childrens.length > 0) {
				return (
					<TreeNode key={id} value={id} title={name} data-item={node} disabled={disabled}>
						{this.renderOrganizationTree(childrens)}
					</TreeNode>
				);
			}

			return <TreeNode key={id} value={id} title={name} data-item={node} disabled={disabled} />;
		});
	}; // 空间项目修改

	onProjectChange = (value) => {
		this.setState({
			communityScope: value,
		});
	}; // 公司范围修改

	onOrganizationChange = (value) => {
		this.setState({
			orgScope: value,
		});
	}; // 获取确定按钮的保存disabled状态

	getBtnDisabledStatus = () => {
		let disabled = false;
		const { customComponentList, showPrivilege } = this.props;
		const {
			selectedObjects,
			showProject,
			communityScope,
			allCommunityScopeFlag,
			showDepartment,
			orgScope,
			allOrgScopeFlag,
			customizeDatum,
			isChoosedAll,
			selectedOperations,
			allPrivileges,
			authErrorMessage,
		} = this.state;
		// console.log(selectedObjects, 'selectedObjects');
		// 授权对象
		if (selectedObjects.length === 0) {
			this.setState({
				showAuthError: true,
				authErrorMessage: '请选择授权对象',
			});
			disabled = true;
		} else if (showProject && allCommunityScopeFlag === CommunityScopeEnum.POSITION && allInvalid(selectedObjects)) {
			this.setState({
				showAuthError: true,
				authErrorMessage: '权限规则仅针对岗位生效',
			});
			disabled = true;
		} else {
			this.setState({
				showAuthError: false,
			});
		}

		// 空间项目范围
		if (showProject && allCommunityScopeFlag === 0 && communityScope.length === 0) {
			this.setState({
				showProjectScopeError: true,
			});
			disabled = true;
		} else {
			this.setState({
				showProjectScopeError: false,
			});
		}

		// 企业范围
		if (showDepartment && allOrgScopeFlag === 0 && orgScope.length === 0) {
			this.setState({
				showDepartmentScopeError: true,
			});
			disabled = true;
		} else {
			this.setState({
				showDepartmentScopeError: false,
			});
		}

		// 自定义组件
		if (customComponentList.length > 0) {
			if (customizeDatum.length < customComponentList.length) {
				disabled = true;
			}

			let customComponentError = {};

			for (let i = 0; i < customComponentList.length; i++) {
				if (!Array.isArray(customizeDatum[i]) || customizeDatum[i].length === 0) {
					disabled = true;

					if (!customComponentError[i]) {
						customComponentError = { ...customComponentError, [i]: true };
					}
				} else {
					if (customComponentError[i]) {
						customComponentError = { ...customComponentError, [i]: false };
					}
				}
			}

			if (!isEqual(customComponentError, this.state.customComponentError)) {
				this.setState({
					customComponentError,
				});
			}
		} // 功能权限

		if (showPrivilege && allPrivileges.length && !this.checkOperationsSelect(selectedOperations)) {
			this.setState({
				showModuleAccessError: true,
			});
			disabled = true;
		} else {
			this.setState({
				showModuleAccessError: false,
			});
		}

		return disabled;
	};

	render() {
		const { type, CustomComponent, hideScope, hideDefaultScope, history, customComponentList, showPrivilege } =
			this.props;
		const { goBack } = history;
		const {
			targetTip,
			scopeTip,
			isChoosedAll,
			allPrivileges,
			readOnly,
			btnLoading,
			preLoading,
			hideProjectBox,
			selectedObjects,
			scopeDatas,
			showObjectModal,
			tmpSelectedObjects,
			showProjectsModal,
			tmpScopeDatas,
			customValues,
			scopeType,
			selectedOperations,
			allCommunityScopeFlag,
			allProjectDisabled,
			communityScope,
			projectTree,
			orgScope,
			organizationTree,
			allDepartmentDisabled,
			allOrgScopeFlag,
			customizeDatum,
			showProject,
			showDepartment,
			disabledSelects,
			isChoosedDisabled,
			allProjectList,
			submitBtnClicked,
			showAuthError,
			authErrorMessage,
			showModuleAccessError,
			showProjectScopeError,
			showDepartmentScopeError,
			// needJobSubdivide
		} = this.state;
		const { organizationId, namespaceId = 1 } = window.$$context;
		const display = hideProjectBox ? 'none' : 'inline-block';
		let title = '新增规则';

		if (type === 'edit') {
			title = '编辑规则';
		} else if (type === 'view') {
			title = '查看规则';
		}

		this.getBtnDisabledStatus();
		const treeCommonProps = {
			treeCheckable: true,
			searchPlaceholder: '请选择',
			showSearch: true,
			multiple: true,
			allowClear: true,
			dropdownStyle: {
				maxHeight: 400,
				overflow: 'auto',
			},
			dropdownMatchSelectWidth: true,
			disabled: readOnly,
			filterTreeNode: this.filterTreeNode,
		};
		const projectTreeProps = {
			value: communityScope.map((pid) => pid.toString()),
			onChange: this.onProjectChange,
			showCheckedStrategy: SHOW_PARENT,
		};
		const organizationTreeProps = {
			value: orgScope,
			onChange: this.onOrganizationChange,
			treeCheckStrictly: true,
		};
		return (
			<div className={prefixCls}>
				<Spin spinning={preLoading} wrapperClassName={prefixCls + '-spin'}>
					<div className={prefixCls + '-content'}>
						<div className={prefixCls + '-content-title'}>{title}</div>
						<div className={prefixCls + '-content-wrapper'}>
							<div className={prefixCls + '-form'}>
								<div className={prefixCls + '-form-label'}>授权给</div>
								<div className={prefixCls + '-form-content'}>
									{selectedObjects.length > 0 && (
										<span className="target-wrapper">
											{selectedObjects.map((target) => {
												const { selectionName = '', sourceIdA, sourceTypeA, isInvalid } = target;
												return (
													<a className="target-item" key={`${sourceTypeA}-${sourceIdA}`}>
														<span className={classNames('target-item-name', isInvalid && 'is_invalid')}>
															{selectionName}
														</span>
														{!readOnly && (
															<i className="iconfont icon-close" onClick={() => this.removeTarget(target)} />
														)}
													</a>
												);
											})}
										</span>
									)}
									{!readOnly && (
										<a className="edit" onClick={this.openObjectModal}>
											编辑
										</a>
									)}
									{submitBtnClicked && showAuthError && (
										<ErrorMessageContianer>{authErrorMessage}</ErrorMessageContianer>
									)}
								</div>
							</div>
							{showProject && (
								<div className={prefixCls + '-form'}>
									<div className={prefixCls + '-form-label'}>管理空间范围</div>
									<div className={prefixCls + '-form-content'}>
										<RadioGroup value={allCommunityScopeFlag} onChange={this.toggleAllProject}>
											<Radio value={CommunityScopeEnum.ALL} disabled={readOnly || allProjectDisabled}>
												全部空间
											</Radio>
											<Radio value={CommunityScopeEnum.COMMUNITY} disabled={readOnly}>
												指定空间
											</Radio>
											{allCommunityScopeFlag === CommunityScopeEnum.COMMUNITY ? (
												<TreeSelect {...treeCommonProps} {...projectTreeProps} placeholder="请选择">
													{this.renderProjectTree(allProjectList)}
												</TreeSelect>
											) : null}
											 <Radio value={CommunityScopeEnum.POSITION} disabled={readOnly}>
											 	根据岗位空间权限
											 </Radio>
										</RadioGroup>
										{submitBtnClicked && showProjectScopeError && <ErrorMessageContianer>请设置</ErrorMessageContianer>}
									</div>
								</div>
							)}
							{showDepartment && showOrgSelector() && (
								<div className={prefixCls + '-form'}>
									<div className={prefixCls + '-form-label'}>管理部门范围</div>
									<div className={prefixCls + '-form-content'}>
										<Radio.Group value={allOrgScopeFlag} onChange={this.updateOrgDataScope}>
											<Radio value={1} disabled={readOnly || allDepartmentDisabled}>
												全公司
											</Radio>
											<Radio value={0} disabled={readOnly}>
												指定部门
											</Radio>
										</Radio.Group>
										{allOrgScopeFlag === 0 ? (
											<TreeSelect {...treeCommonProps} {...organizationTreeProps} placeholder="请选择">
												{this.renderOrganizationTree(organizationTree)}
											</TreeSelect>
										) : null}
										{submitBtnClicked && showDepartmentScopeError && (
											<ErrorMessageContianer>请设置</ErrorMessageContianer>
										)}
									</div>
								</div>
							)}
							{customComponentList.map((customComp, index) => {
								let { label = '', CustomComponent, errorMsg = '' } = customComp;

								if (!label) {
									label = `自定义数据范围${index + 1}`;
								}

								return (
									<div className={prefixCls + '-form'} key={`custom-component-${index}`}>
										<div className={prefixCls + '-form-label'}>
											{label.length > 8 ? <Tooltip title={label}>{label.substr(0, 8) + '...'}</Tooltip> : label}
										</div>
										<div className={prefixCls + '-form-content'}>
											{readOnly && (
												<Fragment>{(customizeDatum[index] || []).map((item) => item.displayName).join('、')}</Fragment>
											)}
											{!readOnly && CustomComponent && (
												<CustomComponent
													type={type}
													componentIndex={index}
													customValues={customizeDatum[index]}
													onChange={this.onCustomComponentChange}
													communityScope={communityScope}
													allCommunityScopeFlag={allCommunityScopeFlag}
													allProjectList={allProjectList}
												/>
											)}
											{submitBtnClicked && this.state?.customComponentError?.[index] && !!errorMsg && (
												<ErrorMessageContianer>{errorMsg}</ErrorMessageContianer>
											)}
										</div>
									</div>
								);
							})}
							{showPrivilege && !!allPrivileges?.length && (
								<div className={prefixCls + '-form'}>
									<div className={prefixCls + '-form-label'}>功能权限</div>
									<div className={`${prefixCls}-form-content`}>
										<div className={`${prefixCls}-form-content-privilege`}>
											{allPrivileges.map((privilege, index) => {
												const { categoryId, categoryName, checked, operations = [], defaultSelect = 0 } = privilege;
												const readOperations = []; // 读权限

												const writeOrOtherOperations = []; // 写权限或其他未知权限（兼容老数据）

												operations.forEach((it, idx) => {
													if (it.operationType === OPERATION_TYPE_DICT.READ) {
														readOperations.push({ ...it, idx });
													} else {
														writeOrOtherOperations.push({ ...it, idx });
													}
												});
												return (
													<div className="privilege-list" key={categoryId}>
														<div className="privilege-list-category">
															<span className="privilege-list-title">{categoryName}</span>
															<Checkbox
																checked={checked}
																disabled={readOnly || defaultSelect === 1}
																onChange={(e) => this.toggleRowAllRights(e, index)}
															>
																全选
															</Checkbox>
														</div>

														{!!readOperations.length && (
															<div className="privilege-list-content privilege-list-content-read">
																{readOperations.map((opera) => {
																	const { id, name = '', checked, defaultSelect = 0, idx } = opera;
																	return (
																		<Checkbox
																			key={id}
																			checked={checked}
																			disabled={readOnly || defaultSelect === 1}
																			onChange={(e) => this.toggleChooseRight(e, index, idx)}
																		>
																			{name}
																		</Checkbox>
																	);
																})}
															</div>
														)}
														{!!writeOrOtherOperations.length && (
															<div className="privilege-list-content">
																{writeOrOtherOperations.map((opera) => {
																	const { id, name = '', checked, defaultSelect = 0, idx } = opera;
																	return (
																		<Checkbox
																			key={id}
																			checked={checked}
																			disabled={readOnly || defaultSelect === 1}
																			onChange={(e) => this.toggleChooseRight(e, index, idx)}
																		>
																			{name}
																		</Checkbox>
																	);
																})}
															</div>
														)}
													</div>
												);
											})}
										</div>
										{submitBtnClicked && showModuleAccessError && (
											<ErrorMessageContianer>请选择授权功能</ErrorMessageContianer>
										)}
									</div>
								</div>
							)}
						</div>
					</div>
					{!readOnly && (
						<div className={prefixCls + '-footer'}>
							<Button onClick={goBack}>取消</Button>
							<Button type="primary" loading={btnLoading} onClick={this.addOrUpdateRule}>
								确定
							</Button>
						</div>
					)}
				</Spin>
				<NewSelectModal
					// test={(state)=>{
					// 	if(state === 1){
					// 		this.setState({
					// 			needJobSubdivide: false
					// 		});
					// 	}
					// 	if(state === 2){
					// 		this.setState({
					// 			needJobSubdivide: true
					// 		});
					// 	}
					// 	if(state === 3){
					// 		this.setState({
					// 			needJobSubdivide: {
					// 				jobSubdivide: 1
					// 			}
					// 		});
					// 	}
					// 	if(state === 4){
					// 		this.setState({
					// 			needJobSubdivide: {
					// 				jobSubdivide: undefined
					// 			}
					// 		});
					// 	}
					// }}
					manageSceneFlag
					visible={showObjectModal}
					organizationId={organizationId}
					types={['department', 'person', 'label', 'position']}
					selects={tmpSelectedObjects}
					configs={{
						person: {
							needAllData: true,
							disabledTip: '已经是此应用的管理员',
						},
						department: {
							needAllData: true,
						},
						position: {
							needAllData: true,
							// needJobSubdivide :true,
						},
					}}
					disabledSelects={disabledSelects}
					onChange={(objects) =>
						void this.setState({
							tmpSelectedObjects: objects,
						})
					}
					onOk={this.confirmSelectObjects}
					onCancel={this.cancelSelectObjects}
					isModal={true}
				/>
			</div>
		);
	}
}

RightDetail.propTypes = {
	type: PropTypes.string.isRequired,
	// 类型: add|view|edit; default: add
	// 展示数据范围类型
	// scopeType: PropTypes.string,
	// 是否显示数据范围的选择框
	// hideScope: PropTypes.bool,
	// 保存成功的回调
	onSave: PropTypes.func,
	// 是否展示管理空间项目范围
	showProjectScope: PropTypes.bool,
	// 是否展示企业范围
	showDepartmentScope: PropTypes.bool,
	// 是否展示功能权限
	showPrivilege: PropTypes.bool,
	// 自定义组件列表
	customComponentList: PropTypes.arrayOf({
		// 组件名称，最多8个字。未定义时为：自定义范围+下标
		label: PropTypes.string,
		// 组件
		CustomComponent: PropTypes.func,
	}),
};
RightDetail.defaultProps = {
	hideScope: false,
	showPrivilege: true,
	customComponentList: [],
};
export default RightDetail;
